import { formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeTranslatableRelationStmtInstruction = `
#### Remove translatable relationship
- Syntax: \`translatable relation <owning_entity>.<owning_field>;\`
- Example: \`translatable relation Book.genres;\`
`;
export const stmtRemoveTranslatableRelation = ({ entityName, fieldName }) => {
    return `remove translatable relation ${entityName}.${fieldName};`;
};
export const stmtForHumanRemoveTranslatableRelation = ({ entityName, fieldName }) => {
    return `Remove the translatable field __${fieldName}__ for table __${entityName}__.`;
};
export const removeTranslatableRelationHandler = createSchemaStatementHandler({
    type: 'remove translatable field',
    parse: line => {
        const match = /^remove translatable (relation|column|field) (?<entityNameName>\w+)\.(?<fieldNameName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove translatable field',
                entityName: formatEntityName(match.groups.entityNameName),
                fieldName: formatFieldName(match.groups.fieldNameName),
            }
            : null;
    },
    getHumanStmt: (stmt) => stmtForHumanRemoveTranslatableRelation(stmt),
    apply: (stmt, builder) => {
        builder.updateSchemaExtensions(it => {
            it.translatable[stmt.entityName] = it.translatable[stmt.entityName] || [];
            if (it.translatable[stmt.entityName].includes(stmt.fieldName)) {
                it.translatable[stmt.entityName] = it.translatable[stmt.entityName].filter(field => field !== stmt.fieldName);
            }
        });
    },
});
//# sourceMappingURL=RemoveTranslatableRelationStmt.js.map